import React from "react";
import { connect } from "react-redux";

import NextGenVisitsError from "./NextGenVisitsError";

const NextGenVisitsErrorContainer = props => {
  return <NextGenVisitsError {...props} />;
};

const mapStateToProps = state => {
  return {
    token: state.auth.token
  };
};

export default connect(mapStateToProps)(NextGenVisitsErrorContainer);



// WEBPACK FOOTER //
// src/pages/NextGenDashboard/NextGenVisitsError.container.js